import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Leaf, Send } from 'lucide-react';
import { TELEGRAM_URL } from '../data/mock';

const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 bg-black overflow-hidden">
      <div className="absolute inset-0 smoke-red opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <img src="/products/site-logo.png" alt="Cali Boyz" className="h-20 w-auto max-w-[260px] object-contain mb-4" />
            <p className="text-white/60 text-sm max-w-xs">Produkty stworzone z pasji do wyjątkowych doznań. Najwyższa jakość THC, niepowtarzalny smak.</p>
            <p className="text-white/30 text-xs mt-4">© {new Date().getFullYear()} Cali Boyz. Wszelkie prawa zastrzeżone.</p>
          </div>

          <div>
            <h4 className="font-anton uppercase text-[#a6e22e] mb-3">Menu</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/" className="hover:text-[#a6e22e]">Strona główna</Link></li>
              <li><Link to="/produkty" className="hover:text-[#a6e22e]">Produkty</Link></li>
              <li><Link to="/o-nas" className="hover:text-[#a6e22e]">O nas</Link></li>
              <li><Link to="/kontakt" className="hover:text-[#a6e22e]">Kontakt</Link></li>
              <li><Link to="/faq" className="hover:text-[#a6e22e]">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-anton uppercase text-[#a6e22e] mb-3">Produkty</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li className="flex items-center gap-1.5"><Leaf size={13} className="text-[#a6e22e]" /> Żelki THC</li>
              <li className="flex items-center gap-1.5"><Leaf size={13} className="text-[#a6e22e]" /> Czekoladki</li>
              <li className="flex items-center gap-1.5"><Leaf size={13} className="text-[#a6e22e]" /> Syropy</li>
              <li className="flex items-center gap-1.5"><Leaf size={13} className="text-[#a6e22e]" /> Tabletki</li>
              <li className="flex items-center gap-1.5"><Leaf size={13} className="text-[#a6e22e]" /> Cali Conez</li>
            </ul>
          </div>

          <div>
            <h4 className="font-anton uppercase text-[#a6e22e] mb-3">Kontakt</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-2"><Mail size={15} className="text-[#a6e22e]" /> kontakt@caliboyz.nl</li>
              <li className="flex items-start gap-2"><MapPin size={15} className="text-[#a6e22e] mt-0.5" /> Cali Boyz Street 420, 00-420 High City</li>
            </ul>
            <a href={TELEGRAM_URL} target="_blank" rel="noreferrer" className="btn-green inline-flex items-center gap-2 mt-4 px-4 py-2 text-sm"><Send size={15} /> Telegram</a>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10 pt-6">
          <img src="/products/site-logo.png" alt="Cali Boyz" className="h-14 w-auto max-w-[220px] object-contain" />
          <div className="flex items-center gap-4 text-white/40 text-xs">
            <Link to="/faq" className="hover:text-white/80">Regulamin</Link>
            <Link to="/faq" className="hover:text-white/80">Polityka prywatności</Link>
            <span className="inline-flex items-center justify-center h-9 w-9 rounded-full border border-[#ff2e2e]/60 text-[#ff5a5a] font-bold">18+</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
